import { useMemo } from "react";
import {
  getQueries,
  ISchoolFeedUrlQueries,
} from "../utils/SchoolBlocksUtilities";
import { IView } from "../stores/InterfaceStore";
import { useStores } from "../stores/useStores";

export const contentTypes: ISchoolFeedContentType[] = [
  "news",
  "media",
  "files",
  "events",
  "coursework",
];

export function useSchoolFeedUrlQuery(): ISchoolFeedUrlQueries {
  const { interfaceStore, organizationStore, userStore } = useStores();

  return useMemo(() => {
    // evaluates url query parameters and checks their integrity
    const queries = getQueries(interfaceStore.currentFullUrl);

    if (
      queries.currentView !== "shop" &&
      ((queries.type &&
        !contentTypes.includes(
          queries.type as never | ISchoolFeedContentType,
        )) || // query type is provided but it's invalid
        (!queries.type && !queries.q)) && // no query type is provided, and we're not searching (allow no type when searching)
      (interfaceStore.view === IView.SCHOOLFEED_PAGE ||
        interfaceStore.view === IView.DEFAULT)
    ) {
      queries.type = "news";
    }
    if (
      userStore.id &&
      (organizationStore.isMyCleverFeed || queries.following)
    ) {
      queries.following = "true";
    } else {
      delete queries.following;
    }
    if (!queries.currentView) {
      queries.currentView = "content";
    }
    return queries;
  }, [interfaceStore.currentFullUrl]);
}
